// index.ts
import { CRUDL, installExtension } from "@juitnow/lib-fetch-client";
export * from "../types/validators.mjs";
var AddressesImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/addresses/v2");
  }
  create(body) {
    return this._crudl.create(body);
  }
  read(uuid) {
    return this._crudl.read(uuid);
  }
  update(uuid, updates) {
    return this._crudl.update(uuid, updates);
  }
  delete(uuid) {
    return this._crudl.delete(uuid);
  }
  list(query) {
    return this._crudl.list(query);
  }
  async validate(body) {
    const response = await this._crudl.http.post("/addresses/v2/validate", body);
    return response.data;
  }
};
installExtension("addresses", AddressesImpl);
export {
  AddressesImpl
};
//# sourceMappingURL=index.mjs.map
